import React, {
    ComponentType,
    useState,
} from 'react'
import Background from '../common/Background'
import {
    Card,
    CardBody,
    CardHeader,
    Col,
    Container,
    Row,
} from 'reactstrap'
import { Link } from 'react-router-dom'

const topGainLogo = '/images/logo.png'

export interface BgProps {
    image: string
    position?: string | { x?: string; y?: string }
}

export interface WithAuthSplitInjectedProps {
    setBgProps: (props: BgProps) => void
}

/**
 * Higher-order component that wraps a component in the split-screen auth layout
 * with a background image panel and a centered card.
 */
const withAuthSplit = <P extends object>(
    OriginalComponent: ComponentType<P & WithAuthSplitInjectedProps>,
): React.FC<Omit<P, keyof WithAuthSplitInjectedProps>> => {
    const UpdatedComponent = (props: Omit<P, keyof WithAuthSplitInjectedProps>) => {
        const [bgProps, setBgProps] = useState<BgProps | null>(null)

        return (
            <Container fluid>
                <Row className='min-vh-100 bg-100'>
                    <Col xs={6} className='d-none d-lg-block'>
                        {bgProps && <Background {...bgProps} />}
                    </Col>
                    <Col
                        sm={10}
                        md={6}
                        className='px-sm-0 align-self-center mx-auto py-5'
                    >
                        <Row noGutters className='justify-content-center'>
                            <Col lg={9} xl={8} className='col-xxl-6'>
                                <Card>
                                    <CardHeader className='bg-split-card-header bg-circle-shape text-center p-2'>
                                        <Link
                                            className='text-white text-sans-serif font-weight-extra-bold fs-4 z-index-1 position-relative'
                                            to='/'
                                        >
                                            <img src={topGainLogo} />
                                        </Link>
                                    </CardHeader>
                                    <CardBody className='p-4'>
                                        <OriginalComponent
                                            setBgProps={setBgProps}
                                            {...(props as P)}
                                        />
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </Container>
        )
    }

    return UpdatedComponent
}

export default withAuthSplit
